// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"0da21a55","744":"ebc889ca","787":"18c1a5f9","914":"e44e0dca","980":"e9865818"}[chunkId] + ".chunk.js";
};